import { createContext, useContext, useEffect, useState } from "react";
import { auth } from "../firebaseConfig";
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import Cookies from "js-cookie";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔐 Monitorar mudanças no token
  useEffect(() => {
    const unsubscribe = auth.onIdTokenChanged(async (firebaseUser) => {
      if (firebaseUser) {
        const token = await firebaseUser.getIdToken();
        const storedUser = JSON.parse(localStorage.getItem("user"));

        const userData = {
          uid: firebaseUser.uid,
          email: firebaseUser.email,
          role: storedUser?.role || "user",
        };

        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(userData));
        setUser(userData);
      } else {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        setUser(null);
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const login = async (email, password) => {
    try {
      if (!Cookies.get("entradaCompleta")) {
        const fallback = {
          params: {},
          referer: document.referrer || null,
          recebidoEm: new Date().toISOString(),
        };
        Cookies.set("entradaCompleta", JSON.stringify(fallback), {
          expires: 7,
          sameSite: "None",
          secure: true,
        });
      }

      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      const token = await user.getIdToken();

      const savedSource = localStorage.getItem("source");
      const savedSourceAfiliado = localStorage.getItem("sourceAfiliado");

      let entradaCompleta = null;
      const rawCookie = Cookies.get("entradaCompleta");

      if (rawCookie) {
        try {
          entradaCompleta = JSON.parse(rawCookie);
        } catch {
          console.warn("⚠️ Cookie entradaCompleta malformado.");
        }
      }

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/login`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          email,
          password,
          source: savedSource,
          sourceAfiliado: savedSourceAfiliado,
          entradaCompleta,
        }),
      });

      const data = await response.json();

      if (!response.ok) throw new Error(data.error || "Erro ao recuperar usuário.");

      const userData = {
        uid: data.userId,
        email,
        role: data.role || "user",
      };

      localStorage.setItem("trackingId", data.trackingId);
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(userData));
      setUser(userData);

      return userData;
    } catch (err) {
      console.error("❌ Erro no login:", err.message);
      throw err;
    }
  };

  const logout = async () => {
    try {
      await signOut(auth);
    } catch (err) {
      console.error("⚠️ Erro ao deslogar:", err.message);
    }
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
  };

  if (loading) return null;

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
